import type { Action } from '@atlassian/react-sweet-state';
import { ISSUE_PARENT } from '../../../../common/constants';
import type { State } from '../../../../common/types';
import { setFilter } from '../common';

export type SetEpicFiltersAction = (epicFilters: string[] | null) => Action<State>;
export const setEpicFilters = setFilter(ISSUE_PARENT);
